import { uuidSchema as e } from "../common/index.js";
import { z as t } from "zod";
// src/identity/base.ts
var n = t.enum(["Agent", "Admin"]).nullable(), r = t.object({
	browserFamily: t.string().min(1).max(80),
	osFamily: t.string().min(1).max(80),
	category: t.enum([
		"phone",
		"tablet",
		"desktop",
		"unknown"
	])
}), i = t.object({
	id: e,
	displayName: t.string().min(1).max(200),
	corporateState: t.enum(["active", "deactivated"]),
	role: n,
	version: t.number().int().positive()
}), a = t.object({
	user: i,
	sessionId: e,
	createdAt: t.iso.datetime(),
	idleExpiresAt: t.iso.datetime(),
	absoluteExpiresAt: t.iso.datetime(),
	csrfToken: t.string().min(32).max(128)
});
export { r as deviceContextSchema, n as roleSchema, a as sessionContextSchema, i as userSummarySchema };

//# sourceMappingURL=base.js.map